// How far a QuoteMaker run has got, as everyone may read it: the furthest step
// of the method its tool calls reached and what its latest call was doing. A
// run's turn count, timings and usage are the cost viewer's only (memory
// feedback_ai_costs_operator_only), so the route sends a business this instead
// of the turns, and the bar's journey line and step words (lucid 019 O1) and
// the Assistant read it. The steps follow the QuoteMaker Method's working order
// (prompt.js WORKING ORDER: read the evidence, write_items, price_items then
// preflight, finish). A step is reached by its first call and never goes back,
// because a fix after a price check writes items again. Pure and shared: the
// browser imports this file.

// What the latest call with a tool was doing, first match wins.
const DOING_BY_TOOL = [
    [/^finish$/, 'finishing'],
    [/^preflight$/, 'checking the quote'],
    [/^price_items$/, 'pricing the items'],
    [/^(write_items|update_item|remove_item)$/, 'writing the items'],
    [/^write_quote_fields$/, 'writing the quote text'],
    [/^raise_confirm$/, 'noting a question for you'],
    [/^(search_rate_book|search_market_price)$/, 'looking up prices'],
    [/^(view_photos|read_video)$/, 'looking at the photos'],
    [/^ask_readers$/, 'checking details across the files'],
    [/^past_quotes$/, 'reading past quotes'],
    [/^client_site_history$/, 'reading the site\'s history'],
    [/^(read_document|list_evidence)$/, 'reading the evidence'],
];

const ITEM_TOOL = /^(write_items|update_item|remove_item)$/;

/**
 * runProgress(turns) -> { reached, doing, fixing }
 *   turns    the run's turns in order, each { tools: string[] } (the tool names it called)
 *   reached  'evidence' until the first item is written, then 'scope', then 'pricing' from the first price or check
 *   doing    what the latest call with a tool was doing; 'thinking' after turns with none; null before the first turn
 *   fixing   at Pricing, the latest call wrote, changed or removed an item (WORKING ORDER 5: a fix, then it prices again)
 */
export function runProgress(turns) {
    const list = Array.isArray(turns) ? turns : [];
    let reached = 'evidence';
    let lastTools = [];
    for (const turn of list) {
        const tools = Array.isArray(turn?.tools) ? turn.tools.filter((t) => typeof t === 'string') : [];
        for (const tool of tools) {
            if (tool === 'price_items' || tool === 'preflight') reached = 'pricing';
            else if (tool === 'write_items' && reached === 'evidence') reached = 'scope';
        }
        if (tools.length) lastTools = tools;
    }
    let doing = list.length ? 'thinking' : null;
    for (const [re, words] of DOING_BY_TOOL) {
        if (lastTools.some((t) => re.test(t))) { doing = words; break; }
    }
    return { reached, doing, fixing: reached === 'pricing' && lastTools.some((t) => ITEM_TOOL.test(t)) };
}
